import angular from 'angular';
import rbSorted from './rb-sorted/rb-sorted.dir';

export default angular.module('rb.directives', [])
  .directive('rbResizeWatcher', require('./rb-resize-watcher/rb-resize-watcher.dir'))
  .directive('rbSorted', rbSorted);
